var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"three"},[_c('div',{staticClass:"human"},[_c('img',{attrs:{"src":"https://gw-resources.uhan.net.cn/Official%20website/3.png","alt":""}})])])
}]

export { render, staticRenderFns }